export const icons = ['x', '<'] as const
